import axios from "axios";
import { API_URL } from "@/services/config.service";

const state = {
  user_groups: [],
  apiUrl: API_URL + "/users/groups",
  axiosConfig: {
    headers: {
      "Content-Type": "application/json"
    }
  }
};

const getters = {
  allUserGroups: state => state.user_groups
};

const mutations = {
  setUserGroups: (state, payload) => (state.user_groups = payload),
  addUserGroup: (state, payload) => state.user_groups.push(payload),
  deleteUserGroup: (state, index) => state.user_groups.splice(index, 1)
};

const actions = {
  fetchUserGroups: async ({ state, commit }) => {
    try {
      const response = await axios.get(state.apiUrl, state.axiosConfig);
      commit("setUserGroups", response.data.user_groups);
      return response.data.user_groups;
    } catch (error) {
      commit("setUserGroups", []);
    }
  },
  saveUserGroup: async ({ state }, payload) => {
    try {
      let response = await axios.post(
        state.apiUrl + "/add",
        payload,
        state.axiosConfig
      );

      if (response.data.message.error) {
        return { error: response.data.message.error };
      }

      if (response.status == 200) {
        return { success: response.data.message.success };
      }
    } catch (error) {}
  },
  updateUserGroup: async ({ state }, payload) => {
    try {
      let response = await axios.put(
        state.apiUrl + "/" + payload["id"],
        payload,
        state.axiosConfig
      );
      if (response.data.message.error) {
        return { error: response.data.message.error };
      }

      if (response.status == 200) {
        return { success: response.data.message.success };
      }
    } catch (error) {}
  },
  deleteUserGroup: async ({ state }, payload) => {
    try {
      let response = await axios.delete(
        state.apiUrl + "/" + payload["id"],
        state.axiosConfig
      );
      if (response.status == 200) {
        state.dispatch("deleteUserGroup", state.countries.indexOf(payload));
        state.notification.push({ message: response.data });
      }
    } catch (error) {}
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
